import { hiddenCols } from './configs';
const defaultHidden = hiddenCols();
/**
 * 控件类型与业务表单匹配
 */

const XTYPE_MAP = {
  'date-local': 'date-picker',
  'multi-select2': 'select-multiple',
  'multi-select': 'select-multiple',
  'multi-tree': 'select-tree',
  'date-ym': 'date-picker',
  'date-range': 'date-picker',
  'date-full': 'date-time-picker',
  uploadfile: 'upload',
  radiolist: 'radio',
  checkboxlist: 'checkbox'
};
/**
 * 数据类型与业务表单匹配
 */

const DATATYPE_MAP = {
  String: 'String',
  Timestamp: 'Date',
  int: 'Number',
  BigString: 'String'
};
export const convertXType = type => {
  return XTYPE_MAP[type] || '';
};
export const convertDataType = type => {
  return DATATYPE_MAP[type] || '';
};
/**
 * 将 Emap 格式控件定义转为表单设计器支持的格式,
 * 如果传入参数为控件列表，则遍历转换每一项,
 * 第二个参数可传入自定义 hides 属性覆盖默认隐藏列数组
 * options.defaultXtype 可自定义若控件未设置 xtype，补充设置的默认值
 */

export const convertControl = (control, {
  hides = defaultHidden,
  defaultXtype = 'text'
} = {}) => {
  if (Object.prototype.toString.call(control) === '[object Array]') {
    return control.filter(item => !item.hidden && !hides.includes(item.prop)).map(item => convertControl(item, {
      hides,
      defaultXtype
    }));
  }

  const {
    xtype,
    dataType,
    checkSize,
    caption,
    url,
    format
  } = control;
  let listQuery;
  const linkage = control['form.linkageBy'];

  if (linkage) {
    listQuery = [{
      name: linkage,
      relation: linkage
    }];
  }

  const ret = {
    xtype: XTYPE_MAP[xtype] || xtype || defaultXtype,
    dataType: DATATYPE_MAP[dataType] || dataType,
    options: { ...control,
      label: caption,
      valueKey: 'id',
      labelKey: 'name',
      maxLength: checkSize,
      format,
      remote: url ? {
        method: 'POST',
        url,
        listPath: 'datas > code > rows',
        listQuery
      } : undefined
    }
  };
  return ret;
};